/**
 * A mensagem de erro que mora embaixo do campo que falhou (rodada V-1).
 *
 * Fica ao lado do problema, e não só no toast: o aviso geral some em 3 segundos
 * e some junto com a informação de QUAL campo estava errado. A mensagem no
 * campo permanece até a pessoa corrigir.
 *
 * `role="alert"` para o leitor de tela anunciar sem precisar de foco — e o
 * `aria-describedby` do input aponta para o `id` daqui (ver uso nos modais).
 */
interface ErroCampoProps {
  /** `id` do input + sufixo `-erro`. Nulo/vazio = nada renderiza. */
  id: string;
  mensagem?: string;
}

export function ErroCampo({ id, mensagem }: ErroCampoProps) {
  if (!mensagem) return null;
  return (
    <p id={`${id}-erro`} role="alert" className="text-xs text-red mt-1">
      {mensagem}
    </p>
  );
}
